export default "__VITE_ASSET__38c2b820__"